module.exports = __webpack_public_path__ + "img/LogoFondoOscuroHorizontal.28b0eac8.png";